import { useCallback, useState } from 'react';

/**
 * Page-size state for a clientPaginate table that should fill the visible area.
 * Pass `pageSize` to `useDataTable` and `onAutoPageSize` to `<DataTable autoPageSize .../>`;
 * the table measures its own scroll box and reports how many rows fit.
 */
export function useAutoPageSize(initial = 15) {
  const [pageSize, setPageSize] = useState(initial);
  const onAutoPageSize = useCallback((rows: number) => setPageSize(rows), []);
  return { pageSize, onAutoPageSize };
}
